export const NavLinks = [
  { path: "/de", label: "Startseite" },
  { path: "/de/about-me", label: "Über mich" },
  { path: "/de/experience", label: "Berufserfahrung" },
  { path: "/de/education", label: "Bildung" },
  { path: "/de/expertise", label: "Kenntnisse" },
];
